import { BalancePolicy, IBalancePolicy } from '../../../../common/BalancePolicy'
import { getMerchantBalancePolicy, setMerchantBalancePolicy } from './api'

/**
 * Учёт баланса мерчанта — тот же блок, что у кассы: одна настройка, один вид.
 * Отличается только последствие отказа, поэтому оно и написано в подтверждении.
 */
export const MerchantBalancePolicy = ({ merchantId }: { merchantId: number }) => (
  <BalancePolicy
    inputId='merchant-enforce-balance'
    confirmText={
      'Выплата не будет создана, если баланса с учётом овердрафта не хватает. ' +
      'Перед включением сверьте баланс мерчанта в Ledger.'
    }
    load={async () => {
      const res = await getMerchantBalancePolicy(merchantId)

      return res.data?.success ? (res.data.data as IBalancePolicy | null) : null
    }}
    save={async (policy) => {
      const res = await setMerchantBalancePolicy(merchantId, policy)

      return res.data?.success ? (res.data.data as IBalancePolicy | null) : null
    }}
  />
)
